<script setup>
import { useAttrs } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';

const attrs = useAttrs();
const globalConfig = useMapGetter('globalConfig/get');
</script>

<template>
  <img
    v-if="globalConfig.logoThumbnail"
    v-bind="attrs"
    :src="globalConfig.logoThumbnail"
  />
  <!-- Fallback = the 뚝닥AI mark (rounded square, mint gradient, bubble +
       spark), same drawing as public/brand-assets/logo_thumbnail.svg so an
       installation without LOGO_THUMBNAIL still shows the brand. -->
  <svg
    v-else
    v-once
    v-bind="attrs"
    width="16"
    height="16"
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <linearGradient id="ddukdoc-mark-gradient" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0" stop-color="#3ED6AB" />
        <stop offset="1" stop-color="#169B7A" />
      </linearGradient>
    </defs>
    <rect width="64" height="64" rx="18" fill="url(#ddukdoc-mark-gradient)" />
    <path
      fill="#fff"
      d="M21 19h18a12 12 0 0 1 12 12 12 12 0 0 1-12 12H27l-7.6 6.2c-1.2 1-3 .1-2.8-1.4l.5-5.4A12 12 0 0 1 9 31a12 12 0 0 1 12-12z"
    />
    <circle cx="22" cy="31" r="2.7" fill="#1C9C7C" />
    <circle cx="30" cy="31" r="2.7" fill="#1C9C7C" />
    <circle cx="38" cy="31" r="2.7" fill="#1C9C7C" />
    <path
      fill="#fff"
      d="M52 6l1.9 5.1L59 13l-5.1 1.9L52 20l-1.9-5.1L45 13l5.1-1.9z"
    />
  </svg>
</template>
